<template>
  <div class="course-name-field element suggest-field row no-gutters">
    <div class="col-12 suggest-field-wrap" v-click-outside="clearResults">
      <div class="suggest-field-input-wrap">
        <input type="text" name="name" v-model="name" class="form-control" />
        <icon v-if="showLoadingIcon" icon="loading" class="icon" />
      </div>
      <ul v-if="results.length > 0" class="suggest-field-results">
        <li class="suggest-field-info text-center py-3">
          <p class="mb-0">
            The following courses have a similar name to the name you have entered.
            <br />Would you like to
            <strong class="text-danger">clone</strong> one of these courses?
          </p>
        </li>
        <li v-for="(item, i) in results" :key="i">
          <a href="#" @click.prevent="cloneCourse(item)">{{ item.label }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: "" }
  },
  data() {
    return {
      name: "",
      results: [],
      showLoadingIcon: false
    };
  },
  watch: {
    name(val) {
      if (val.length > 0) {
        this.refresh();
      } else {
        setTimeout(() => {
          this.results = [];
        }, 300);
      }
    }
  },
  methods: {
    refresh: _.debounce(function() {
      if (this.name.length === 0) return;
      this.showLoadingIcon = true;
      this.axios
        .get(this.route("admin.courses.search"), {
          params: { keywords: this.name }
        })
        .then(response => {
          this.results = response.data.results;
          this.showLoadingIcon = false;
        })
        .catch(error => {
          console.error(error);
          this.showLoadingIcon = false;
          this.clearResults();
        });
    }, 300),
    clearResults() {
      this.results = [];
    },
    cloneCourse(course) {
      this.$emit("clone", course);
    }
  },
  created() {
    this.name = this.value;
  }
};
</script>
